import styled from "styled-components";
import { Rate } from "antd";
export const RatingDiv = styled(Rate)``;
